(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warning-category', {
                parent: 'alerting',
                url: '/warning-category?page&sort&search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-categories.html',
                        controller: 'WarningCategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    predicates:{},
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates:  $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warning-category-detail', {
                parent: 'entity',
                url: '/warning-category/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-category-detail.html',
                        controller: 'WarningCategoryDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WarningCategory', function ($stateParams, WarningCategory) {
                        return WarningCategory.get({id: $stateParams.id});
                    }]
                }
            })
            .state('warning-category-new', {
                parent: 'warning-category',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-category-dialog.html',
                        controller: 'WarningCategoryDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            warningName: null,
                            id: null
                        };
                    }
                }
            })
            .state('warning-category.edit', {
                parent: 'warning-category',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warning-category/warning-category-dialog.html',
                        controller: 'WarningCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarningCategory', function (WarningCategory) {
                                return WarningCategory.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warning-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warning-category.delete', {
                parent: 'warning-category',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warning-category/warning-category-delete-dialog.html',
                        controller: 'WarningCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WarningCategory', function (WarningCategory) {
                                return WarningCategory.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warning-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
